/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import CurrentPageContext from '../../../contexts/CurrentPageContext';
import images from './assets';
import classes from './SizeSuggestion.scss';

export default class SizeSuggestion extends React.Component {
  static propTypes = {
    unitSize: PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      volume: PropTypes.number.isRequired,
    }),
    volume: PropTypes.number,
  };

  static defaultProps = {
    unitSize: undefined,
    volume: undefined,
  };

  static contextType = CurrentPageContext;

  renderTooLarge() {
    const { secondaryColorClass } = this.context;

    return (
      <p className={cx(secondaryColorClass, classes.sizeWarning)}>
        You've exceeded the largest size available in this calculator. Check in with
        a facility manager about available larger unit sizes or about renting multiple
        units.
      </p>
    );
  }

  renderNoSuggestion() {
    const { secondaryColorClass } = this.context;

    return (
      <div className={classes.noSuggestion}>
        <p className={cx(secondaryColorClass, classes.sizeWarning)}>
          To receive a size suggestion, select the items you wish to store.
        </p>
        <img src={images['5x5']} alt="5x5" className={classes.unitImage} />
      </div>
    );
  }

  render() {
    const { unitSize, volume } = this.props;

    if (!unitSize) {
      return this.renderNoSuggestion();
    }

    const { primaryColorClass, secondaryColorClass } = this.context;
    const capacity = (volume / unitSize.volume) * 100;
    const overCapacity = capacity > 100;

    return (
      <div className={overCapacity ? classes.noSuggestion : null}>
        {overCapacity ? this.renderTooLarge() : null}
        <img src={images[unitSize.id]} alt={unitSize.id} className={classes.unitImage} />
        <div className={cx(primaryColorClass, classes.heading)}>
          {unitSize.id}
          <span className={cx(secondaryColorClass, classes.capacity)}>
            {overCapacity ? 'over 100' : capacity.toFixed(0)}% full
          </span>
        </div>
        <p>
          {unitSize.description}
        </p>
      </div>
    );
  }
}
